import { Box, Typography } from "@mui/material";
import React from "react";

const COLORS_BY_ENVIRONMENT: Record<string, { color: string; bgcolor: string }> = {
    demo: {
        color: "white",
        bgcolor: "orange",
    },
    staging: {
        color: "black",
        bgcolor: "yellow",
    },
    development: {
        color: "white",
        bgcolor: "info.main",
    },
};

const environment = process.env.NEXT_PUBLIC_APP_ENV;

interface IProps {
    asSpacer?: boolean;
}

export const EnvironmentBar: React.FC<IProps> = ({ asSpacer }) => {
    if (!environment || environment === "production") {
        return null;
    }

    return (
        <Box
            sx={({ zIndex: { appHeader: zIndex } }) => ({
                minHeight: 20,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex,
                ...COLORS_BY_ENVIRONMENT[environment],
            })}
        >
            {!asSpacer && (
                <Typography
                    align="center"
                    fontWeight="bold"
                    fontSize="0.75rem"
                    lineHeight={1}
                    letterSpacing={1}
                    textTransform="uppercase"
                >
                    {environment}
                </Typography>
            )}
        </Box>
    );
};
